var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"wangeditor"}},[_c('div',{ref:"editorProgressElem",staticStyle:{"text-align":"left"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }